module.exports = __webpack_public_path__ + "media/images/Icon-18c7ba7bbd00869e516157a2211b7661.png";